import { PaymentFaild } from "@/types/gtm/QuoteReviewEvent";
import { QuoteData } from "@/types/quote/quote-data";

function paymentFailedDataMap(
  attributes: QuoteData["attributes"],
  errorMassageTitle: string,
  isDataMap?: boolean,
  event?: string,
  eventName?: string,
  step_name?: string,
  project: "quote" | "renewal" = "quote"
) {
  const { paymentDetails } = attributes;
  let mapData = {} as PaymentFaild;
  if (paymentDetails && isDataMap) {
    mapData = {
      event: event ?? "site_errors",
      event_name: eventName ?? "payment_failed",
      error_message: errorMassageTitle,
      payment_type: paymentDetails.paymentOption,
    } as unknown as PaymentFaild;

    if (project === "renewal") {
      mapData.step_name = step_name ?? "renewal_payment_error";
    }
  }
  return mapData;
}

export default paymentFailedDataMap;
